<div
  class="{{ noColor ? '' : type + '-text' }}"
  fxLayout
  fxLayoutAlign="start start"
  [fxLayoutGap]="0.25 | dsSpacing"
  data-test="wrapper"
>
  <span fxFlex="0 0 auto">
    <mat-icon
      [ngStyle]="
        iconSize
          ? { width: iconSize, height: iconSize, 'font-size': iconSize }
          : {}
      "
      data-test="icon"
      >{{ type === 'success' ? 'check_circle' : type }}</mat-icon
    >
  </span>
  <span fxFlex="0 1 auto" data-test="text"><ng-content></ng-content></span>
</div>
